module.exports = __webpack_public_path__ + "static/about_gallery-b874a81946a2d35d5803580073e8f051.png";